<template>
  <div class="app">
    <nav class="navbar">
      <div class="logo-container">
        <img class="logo-img" src="./assets/logo4.png" alt="Logo">
        <span class="company-name">Aksoy Değer Kaybı Danışmanlığı</span>
      </div>
      <div class="nav-links">
        <a @click="scrollTo('home')" href="#">Ana Sayfa</a>
        <a @click="scrollTo('about')" href="#">Hakkımızda</a>
        <a @click="scrollTo('cases')" href="#">Hikayeler</a>
      </div>
    </nav>

    <section id="home" class="hero">
    <div class="hero-content">
      <div class="hero-text">
        <h1>Değer Kaybı Mağdurlarının<br><span class="highlight">Güvenilir Çözüm Ortağı</span></h1>
        <p class="hero-description">Karmaşık hukuki süreçlerde size yol gösteriyoruz</p>
        <div class="hero-stats">
          <div class="stat">
            <span class="stat-number">10+</span>
            <span class="stat-label">Yıllık Tecrübe</span>
          </div>
          <div class="stat">
            <span class="stat-number">500+</span>
            <span class="stat-label">Başarılı Vaka</span>
          </div>
          <div class="stat">
            <span class="stat-number">98%</span>
            <span class="stat-label">Müvekkil Memnuniyeti</span>
          </div>
        </div>
        <button @click="scrollTo('about')" class="cta-button">Hizmetlerimizi İnceleyin</button>
      </div>
    </div>
  </section>


  <section id="about" class="about">
    <div class="about-content">
      <h2>Neden Biz?</h2>
      <div class="about-grid">
        <div class="about-card">
          <div class="about-icon">🏆</div>
          <h3>Uzmanlık</h3>
          <p>20 yıllık tecrübemiz ve alanında uzman avukatlarımızla trafik kazası hukuku ve değer kaybı konusunda Türkiye'nin önde gelen danışmanlık şirketiyiz.</p>
        </div>
        <div class="about-card">
          <div class="about-icon">⚡</div>
          <h3>Hızlı Çözüm</h3>
          <p>Vakalarımızın %85'ini max 45 gün içerisinde sonuçlandırıyor, müvekkillerimizin haklarını en kısa sürede almalarını sağlıyoruz.</p>
        </div>
        <div class="about-card">
          <div class="about-icon">💪</div>
          <h3>Güçlü Network</h3>
          <p>Türkiye genelinde 50'den fazla sigorta şirketi ile kurduğumuz güçlü iş birlikleri sayesinde süreçlerinizi hızlandırıyoruz.</p>
        </div>
        <div class="about-card">
          <div class="about-icon">🤝</div>
          <h3>Şeffaf İletişim</h3>
          <p>Süreç boyunca size atanan özel danışmanınız düzenli olarak bilgilendirme yaparak kafanızdaki soru işaretlerini gideriyor.</p>
        </div>
      </div>
      
      <div class="team-section">
      <h3>Uzmanımız</h3>
      <div class="team-single">
        <div class="member-photo">
          <img src= "./assets/foto3.png" alt="Uzm. Ömer Faruk Yeter"></div>
        <h4>Uzm. Ömer Faruk Yeter</h4>
        <p>Değer Kaybı Uzmanı</p>
      </div>
    </div>
    </div>
  </section>

  <section id="cases" class="cases">
    <h2>Başarı Hikayeleri</h2>
    <div class="cases-grid">
      <div class="case-card">
        <div class="case-header">
          <span class="case-tag">Tazminat</span>
          <span class="case-amount">₺450.000</span>
        </div>
        <p class="case-description">Ankara'da meydana gelen zincirleme trafik kazasında müvekkilimizin haklarını başarıyla savunduk.</p>
        <div class="case-footer">
          <span class="case-duration">Süre: 2.5 ay</span>
        </div>
      </div>
      <div class="case-card">
        <div class="case-header">
          <span class="case-tag">Maluliyet</span>
          <span class="case-amount">₺780.000</span>
        </div>
        <p class="case-description">Ticari araçların onarım süresi içerindeki mağduriyetlerini karşılamak için kiralik araç bedeli tazmininin sigorta şirketinden alınması.</p>
        <div class="case-footer">
          <span class="case-duration">Süre: 85 gün</span>
        </div>
      </div>
      <div class="case-card">
        <div class="case-header">
          <span class="case-tag">Tazminat</span>
          <span class="case-amount">₺280.000</span>
        </div>
        <p class="case-description">Trafik kazası sonrası araçta meydana gelen değer kaybının tazmini için sigorta şirketine başvuru yapılarak müvekkilin zararı karşılandı.</p>
        <div class="case-footer">
          <span class="case-duration">Süre: 2 ay</span>
        </div>
      </div>
    </div>
  </section>

  <footer>
  <div class="footer-content">
    <div class="footer-logo">
      <img class="logo-img" src="./assets/logo4.png" alt="Logo">
      <p>Aksoy Değer Kaybı Danışmanlığı</p>
    </div>
    <div class="social-links">
      <a href="mailto:aksoydegerkaybi@gmail.com" class="social-button email-button" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      </a>
      <a href="https://www.facebook.com/share/15qQXtWzPe/?mibextid=wwXIfr" class="social-button facebook-button" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
        </svg>
      </a>
      <a href="https://www.instagram.com/aksoydegerkaybi?igsh=MXQzb2NwdmZlbnRiMQ%3D%3D&utm_source=qr" class="social-button instagram-button" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
        </svg>
      </a>
    </div>
    <p class="copyright">© 2025 Aksoy Aracılık Hizmetleri. Tüm hakları saklıdır.</p>
  </div>
</footer>

<a href="https://wa.me/905326656669?text=Merhaba%2C%20aracımın%20değer%20kaybı%20tazminatı%20hakkında%20bilgi%20almak%20istiyorum.%20Yardımcı%20olabilir%20misiniz%3F" class="whatsapp-button" target="_blank">
    <svg viewBox="0 0 24 24" fill="#FFFFFF">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
    </svg>
</a>
  </div>
</template>

<script>
export default {
  methods: {
    scrollTo(elementId) {
      const element = document.getElementById(elementId)
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>

<style>
:root {
  --primary-black: #1a1a1a;
  --secondary-black: #2a2a2a;
  --accent-yellow: #ffd700;
  --subtle-yellow: rgba(255, 215, 0, 0.1);
  --text-gray: #888;
}
.logo-img {
  width: 100px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', sans-serif;
  line-height: 1.6;
  color: var(--primary-black);
  background: #fff;
}

.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 10%;
  background: var(--secondary-black);
  box-shadow: 0 2px 20px rgba(0,0,0,0.2);
  z-index: 1000;
}

.logo {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--primary-black);
  letter-spacing: -1px;
}

.nav-links a {
  margin-left: 3rem;
  text-decoration: none;
  color: white;
  font-weight: 500;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: var(--accent-yellow);
}

section {
  padding: 8rem 10%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.hero {
  background: linear-gradient(rgba(26,26,26,0.9), rgba(26,26,26,0.9));
  color: white;
  text-align: center;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.hero h1 {
  font-size: 4rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  letter-spacing: -2px;
}

.highlight {
  color: var(--accent-yellow);
}

.hero p {
  font-size: 1.2rem;
  color: var(--text-gray);
  margin-bottom: 2rem;
}

.cta-button {
  padding: 1.2rem 3rem;
  font-size: 1.1rem;
  background: var(--accent-yellow);
  color: var(--primary-black);
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 600;
  transition: transform 0.3s, box-shadow 0.3s;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.2);
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 3rem;
  margin-top: 4rem;
}

.service-card {
  padding: 3rem;
  background: white;
  border-radius: 20px;
  text-align: center;
  transition: transform 0.3s;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
}

.service-card:hover {
  transform: translateY(-10px);
}

.service-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
}

.service-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: var(--primary-black);
}

.service-card p {
  color: var(--text-gray);
}

.about {
  background: var(--subtle-yellow);
}

.about-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.contact-form {
  display: flex;
  flex-direction: column;
  max-width: 600px;
  margin: 0 auto;
  gap: 1.5rem;
}

.contact-form input,
.contact-form textarea {
  padding: 1.2rem;
  border: 2px solid #eee;
  border-radius: 12px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

.contact-form input:focus,
.contact-form textarea:focus {
  border-color: var(--accent-yellow);
  outline: none;
}

.contact-form textarea {
  height: 200px;
  resize: vertical;
}

.submit-button {
  padding: 1.2rem;
  background: var(--primary-black);
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background: var(--secondary-black);
}

footer {
  text-align: center;
  padding: 3rem;
  background: var(--primary-black);
  color: white;
}

.whatsapp-button {
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 70px;
  height: 70px;
  background-color: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  z-index: 1000;
  transition: transform 0.3s;
}

.whatsapp-button svg {
  width: 40px;
  height: 40px;
}

.whatsapp-button:hover {
  transform: scale(1.1);
}

h2 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  font-weight: 700;
  letter-spacing: -1px;
}

@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    padding: 1rem;
  }
  .hero-content{
    margin-top: 100px;
  }

  .nav-links {
    margin-top: 1rem;
  }

  .nav-links a {
    margin: 0 1rem;
    font-size: 0.9rem;
  }

  .hero h1 {
    font-size: 2.5rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
  }

  .whatsapp-button {
    width: 50px;
    height: 50px;
    bottom: 20px;
    right: 20px;
  }
}

.hero {
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(26,26,26,0.95), rgba(26,26,26,0.8)), 
              url('https://via.placeholder.com/1920x1080') center/cover;
  z-index: -1;
}

.hero-stats {
  display: flex;
  justify-content: center;
  gap: 4rem;
  margin: 3rem 0;
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--accent-yellow);
}

.stat-label {
  color: var(--text-gray);
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.about-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin: 4rem 0;
}

.about-card {
  background: white;
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
}

.about-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.about-card h3 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: var(--primary-black);
}

.team-section {
  margin-top: 6rem;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  margin-top: 2rem;
}

.team-member {
  text-align: center;
}

.member-photo {
  width: 200px;
  height: 200px;
  background: #eee;
  border-radius: 50%;
  margin: 0 auto 1.5rem;
}
.member-photo img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 3rem;
}

.case-card {
  background: white;
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
}

.case-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.case-tag {
  background: var(--subtle-yellow);
  color: var(--primary-black);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
}

.case-amount {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--primary-black);
}

.case-footer {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

@media (max-width: 768px) {
  .hero-stats {
    flex-direction: column;
    gap: 2rem;
  }

  .about-grid,
  .team-grid,
  .cases-grid {
    grid-template-columns: 1fr;
  }
}
.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px; /* Consistent spacing between logo and text */
}

.company-name {
  color: white;
  font-size: 1.25rem; /* Larger font size */
  font-weight: bold; /* Medium weight for better readability */
  letter-spacing: 0.5px; /* Slight letter spacing for elegance */
  text-align: center;
  line-height: 1.2;
  margin-top: 0.25rem;
  white-space: nowrap; /* Prevents awkward text wrapping */
}

.team-section {
  margin-top: 6rem;
}

.team-single {
  max-width: 300px;
  margin: 0 auto;
  text-align: center;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.footer-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.footer-logo img {
  width: 80px;
}

.footer-logo p {
  color: white;
  font-size: 1.1rem;
}

.social-links {
  display: flex;
  gap: 1.5rem;
}

.social-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--accent-yellow);
  color: var(--primary-black);
  transition: transform 0.3s;
}

.social-button:hover {
  transform: scale(1.1);
}

.copyright {
  margin-top: 1rem;
}

@media (max-width: 768px) {
  .company-name {
    font-size: 1rem; /* Smaller font size on mobile */
  }
  .logo-img {
    width: 80px; /* Slightly smaller on mobile */
  }
  
  .footer-logo img {
    width: 60px;
  }
  
  .social-button {
    width: 35px;
    height: 35px;
  }
}
</style>